module.exports = __webpack_public_path__ + "img/serin.d395f6ad.png";